import styled from 'styled-components';

export const StyledMicrophoneLevelTrack = styled.div`
   position: relative;
   width: 100%;
   height: 10px;
   border-radius: 9px;
   background-color: ${(props) => props.theme.successLighter};
`;

StyledMicrophoneLevelTrack.displayName = 'StyledMicrophoneLevelTrack';

type StyledMicrophoneLevelFillProps = {
   $level: number;
};

export const StyledMicrophoneLevelFill = styled.div.attrs<StyledMicrophoneLevelFillProps>((props) => ({
   style: { width: `${props.$level}%` },
}))<StyledMicrophoneLevelFillProps>`
   position: absolute;
   top: 0;
   left: 0;
   height: 10px;
   border-radius: 9px;
   background-color: ${(props) => props.theme.success};
`;

StyledMicrophoneLevelFill.displayName = 'StyledMicrophoneLevelFill';
